'use client';

import React__default, { useState } from 'react';
import { StyledFormView, ExternalTag, ViewContainer, StyledBlock, MainContentWrapper, StyledMainContent, Title, IconGroup, Extend, BodyBottomSheet, ItemBottomSheet } from './styled.css.js';
import Pencil from '../Images/Pencil/index.js';
import Button from '../Button/index.js';
import Trash from '../Images/Trash/index.js';
import ThreeDotIcon from '../Images/ThreeDotIcon/index.js';
import BottomSheet from '../BottomSheet/index.js';
import { ELanguage } from '../Utils/constants.js';
import translations from './translations.js';

function FormView(_a) {
    var title = _a.title, children = _a.children, vBlocks = _a.vBlocks, handleEdit = _a.handleEdit, handleDelete = _a.handleDelete, handleClick = _a.handleClick, extendContent = _a.extendContent, _b = _a.isMobile, isMobile = _b === void 0 ? false : _b, _c = _a.hasError, hasError = _c === void 0 ? false : _c, _d = _a.hiddenEdit, hiddenEdit = _d === void 0 ? false : _d, className = _a.className, style = _a.style, customAction = _a.customAction, externalTag = _a.externalTag, mode = _a.mode, _e = _a.lang, lang = _e === void 0 ? ELanguage.VI : _e;
    var _f = (customAction || {}).position, position = _f === void 0 ? 'start' : _f;
    var _g = useState(false), isExendted = _g[0], setIsExtended = _g[1];
    var _h = useState(false), isShowBottomSheet = _h[0], setIsShowBottomSheet = _h[1];
    // const handleClickWholeBox = isMobile ? () => {} : handleClick
    // const handleClickIconEdit = isMobile ? handleClick : () => {}
    var t = function (text) {
        if (lang === 'vi') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var handleClickOnBox = function (e) {
        e.preventDefault();
        setIsExtended(!isExendted);
    };
    var handleShowBottomSheet = function () {
        setIsShowBottomSheet(!isShowBottomSheet);
    };
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledFormView, { isMobile: isMobile, hasError: hasError, className: className, style: style },
            externalTag ? React__default.createElement(ExternalTag, { isMobile: isMobile }, externalTag) : null,
            React__default.createElement(ViewContainer, { onClick: handleClickOnBox },
                vBlocks.map(function (block, index) { return (React__default.createElement(StyledBlock, { key: index }, block)); }),
                React__default.createElement(MainContentWrapper, null,
                    React__default.createElement(StyledMainContent, null,
                        React__default.createElement(Title, null,
                            title,
                            " "),
                        children),
                    React__default.createElement(IconGroup, { className: 'icon-group', isMobile: isMobile, position: position }, !isMobile ? (React__default.createElement(React__default.Fragment, null,
                        !hiddenEdit ? (React__default.createElement(Button, { isRounded: true, isIcon: true, type: 'transparent', onClick: mode === 'myProfile' ? handleEdit : handleClick },
                            React__default.createElement(Pencil, null))) : null,
                        mode === 'myProfile' && (React__default.createElement(Button, { isRounded: true, isIcon: true, type: 'transparent', onClick: handleDelete },
                            React__default.createElement(Trash, null))))) : (React__default.createElement(Button, { isRounded: true, isIcon: true, type: 'transparent', onClick: handleShowBottomSheet },
                        React__default.createElement(ThreeDotIcon, null))))),
                extendContent ? React__default.createElement(Extend, { isExtend: isExendted !== null && isExendted !== void 0 ? isExendted : false }, extendContent) : null)),
        isShowBottomSheet && (React__default.createElement(BottomSheet, { onClose: handleShowBottomSheet, isOpen: isShowBottomSheet, header: '', 
            // footer={<></>}
            footerOptions: {
                buttonType: 'default',
                text: t('Cancel')
            } },
            React__default.createElement(BodyBottomSheet, null,
                !hiddenEdit ? (React__default.createElement(ItemBottomSheet, { onClick: mode === 'myProfile' ? handleEdit : handleClick },
                    React__default.createElement(Button, { type: 'transparent', isRounded: true, isIcon: true },
                        React__default.createElement(Pencil, null)),
                    ' ',
                    t('Edit'))) : null,
                mode === 'myProfile' && (React__default.createElement(ItemBottomSheet, { onClick: handleDelete },
                    React__default.createElement(Button, { type: 'transparent', isRounded: true, isIcon: true },
                        React__default.createElement(Trash, null)),
                    t('Delete'))))))));
}

export { FormView as default };
//# sourceMappingURL=index.js.map
